import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

import globals from '@/globals'

import { userService } from '../components/Auth/_services'
import { store } from '../backend/vuex-storage/globalStoreParameters'

// Layouts
// import Layout1 from '@/layout/Layout1'
import HorizontalMenu from '@/layout/LayoutHorizontalSidenav'
import Blank from '@/layout/LayoutBlank'

Vue.use(Router)
Vue.use(Meta)

let timer

export const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '/',
    component: Blank,
    children: [{
      path: '',
      component: () => import('@/components/Auth/auth'),
      children: [{
        path: '',
        component: () => import('@/components/Auth/components/login')
      }, {
        path: 'register',
        component: () => import('@/components/Auth/components/register')
      }, {
        path: 'passwordRecovery',
        component: () => import('@/components/Auth/components/passwordRecovery')
      }]
    }, {
      path: 'page-2',
      component: () => import('@/components/Page2')
    }]
  },
  {
    path: '/Aml',
    component: HorizontalMenu,
    name: 'AML',
    children: [{
      path: 'Requests',
      component: () => import('@/components/Aml/requests/requests')
    }, {
      path: 'Requests/ApprovedRequests',
      component: () => import('@/components/Aml/requests/approvedrequests')
    }, {
      name: 'InvestigatingRequest',
      path: 'Requests/InvestigatingRequest',
      component: () => import('@/components/Aml/requests/investigatingrequest'),
      props: true
    }, {
      path: 'Requests/BlockedRequests',
      component: () => import('@/components/Aml/requests/blockedrequests')
    }, {
      path: 'Requests/NotProcessedRequests',
      component: () => import('@/components/Aml/requests/notprocessedrequests')
    },
    {
      path: 'Lists/BlackList',
      component: () => import('@/components/Aml/lists/blacklist')
    }, {
      path: 'Lists/WhiteList',
      component: () => import('@/components/Aml/lists/whitelist')
    }, {
      path: 'ClientDBScreening',
      component: () => import('@/components/Aml/clientsdbscreening/clientsdb')
    }, {
      name: 'ClientScreeningDetails',
      path: 'ClientDBScreening/ClientScreeningDetails',
      component: () => import('@/components/Aml/clientsdbscreening/clientScreeningDetails'),
      props: true
    }, {
      path: 'DBUpdates/UN',
      component: () => import('@/components/Aml/dbupdates/un')
    }, {
      path: 'DBUpdates/UN/IndividualsDetails',
      component: () => import('@/components/Aml/components/unIndDetails')
    },
    {
      path: 'TransactionSubjects/SubjectRequests',
      component: () => import('@/components/Aml/subjectScreening/subjectRequests')
    },
    {
      path: 'TransactionSubjects/SubjectRequests/PossibleOptions',
      component: () => import('@/components/Aml/subjectScreening/possibleOptions')
    },
    {
      path: 'DBUpdates/USA',
      component: () => import('@/components/Aml/dbupdates/ofac')
    },
    {
      path: 'DBUpdates/UK',
      component: () => import('@/components/Aml/dbupdates/uk')
    },
    {
      path: 'DBUpdates/EU',
      component: () => import('@/components/Aml/dbupdates/eu')
    }]
  },
  {
    path: '/System',
    component: HorizontalMenu,
    name: 'System',
    children: [{
      path: 'GlobalSettings',
      component: () => import('@/components/System/globalSettings')
    },
    {
      path: 'UsersManagement',
      component: () => import('@/components/System/usersManagement')
    },
    {
      path: 'WhiteListSettings',
      component: () => import('@/components/System/whiteListSettings')
    },
    {
      path: 'BlackListSettings',
      component: () => import('@/components/System/blackListSettings')
    },
    // {
    //   path: 'GeneralSettings',
    //   component: () => import('@/components/System/generalSettings')
    // },
    {
      path: 'ScanningSettings',
      component: () => import('@/components/System/scanningSettings')
    }]
  },
  {
    // 404 Not Found page
    path: '*',
    component: NotFound
  }]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  document.body.classList.add('app-loading')

  const publicPages = ['/', '/passwordRecovery', '/register']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('user')

  if (authRequired && !loggedIn) {
    return next('/')
  }

  // Refresh Access token
  if (to.path !== '/') {
    const expireIn = new Date(store.getters.getJWTokenExpires).getTime() - new Date().getTime()
    timer = setTimeout(() => {
      // refreshToken()
      userService.refreshToken()
    }, expireIn)
    // console.log('timer started')
    // console.log(expireIn)
  } else {
    clearTimeout(timer)
    // console.log('timer cleared')
    // console.log(timer)
  }
  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
